<template>
  <div>
    <app-view-layout
      header="DKO Współpraca"
      fluid
      no-padding
    >
      <template #toolbarMenu>
        <DkoToolbarMenu />
      </template>
      <template #content>
        <v-card>
          <div class="py-0 px-8">
            <v-tabs v-model="tab">
              <v-tab
                v-for="option in options"
                :key="option.tab"
                @click="showTab(option)"
              >
                {{ option.tab }}
              </v-tab>
            </v-tabs>
          </div>
        </v-card>
        <div class="pt-8 pb-4 px-8">
          <v-card
            class="py-6 px-8"
            flat
            tile
          >
            <DkoTable
              :header="activeOption.title"
              :requests="list"
              :empty-header="emptyHeader"
              :empty-text="emptyText"
            />
            <AppPagination
              v-if="list.length"
              class="mt-6"
              @change="fetchList"
            />
          </v-card>
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import DkoTable from '@/components/DkoCooperation/DkoTable.vue';
import DkoToolbarMenu from '@/components/DkoCooperation/DkoToolbarMenu.vue';

export default {
  components: {
    AppPagination,
    AppViewLayout,
    DkoTable,
    DkoToolbarMenu,
  },
  data() {
    return {
      tab: 0,
      options: [
        { status: 'pending', tab: 'Lista wniosków', title: 'Lista nowych wniosków' },
        { status: 'accepted', tab: 'Zaakceptowane wnioski', title: 'Zaakceptowane wnioski' },
        { status: 'rejected', tab: 'Odrzucone wnioski', title: 'Odrzucone wnioski' },
        { status: 'archive', tab: 'Archiwum', title: 'Archiwum' },
        {
          forPrint: true,
          tab: 'Do druku',
          title: 'Do druku',
          emptyHeader: 'Brak dokumentów do druku',
          emptyText: 'Nie masz wniosków oznaczonych flagą „do druku”.',
        },
      ],
    };
  },
  computed: {
    ...mapState('dkoCooperation', ['list', 'listUnavailable']),
    ...mapState('filters', ['filtersOptions']),
    activeOption() {
      return this.options[this.tab] || this.options[0];
    },
    emptyHeader() {
      if (this.listUnavailable) return 'Lista do druku jest niedostępna';
      return this.activeOption.emptyHeader;
    },
    emptyText() {
      if (this.listUnavailable) return 'Nie udało się pobrać listy dokumentów do druku.';
      return this.activeOption.emptyText;
    },
  },
  created() {
    if (!this.filtersOptions.departments?.length) this.fetchFiltersOptions();
    this.showTab(this.options[0]);
  },
  methods: {
    ...mapActions('dkoCooperation', ['setListQuery', 'fetchList']),
    ...mapActions('filters', ['fetchFiltersOptions']),
    showTab(option) {
      if (option.forPrint) {
        return this.setListQuery({ status: null, forPrint: true });
      }
      return this.setListQuery({ status: option.status, forPrint: false });
    },
  },
};
</script>
